import React from 'react';
import "./GrowWithUs.css"

export default function GrowWithUs (){

  return(
    <div className="gwu-main-container">
      <div className="top-text-container">
      <p className="gwu-text">
        FFTI will always be there to encourage talented aspirants.
        FFTI have heard several stories of franchisors of its own ,
        who have been successful in their business. You can also be one of them or top of them, if you join with us.
      </p>
        <marquee behavior="scroll" direction="left">
          YOU CAN GRAB YOUR OPPORTUNITY BY CONTACTING US THROUGH MANAGEMENT PAGE
        </marquee>
      
      </div>

      <div className="franchise-main-container">
        <div className="franchise-ind-container">
          <img className='store-img' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSavnG53v9VShRYJOjX45mgRcj1m8JovZiVdA&usqp=CAU" alt="store-img"/>
          <p className='store-text'>Tadipatri</p>
        </div>

        <div className="franchise-ind-container">
          <img className='store-img' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQF-Ry5awogpcTmqBYyOphTyzGX4CpeiOKhGg&usqp=CAU" alt="store-img"/>
          <p className='store-text'>Dharmavaram</p>
        </div>

        <div className="franchise-ind-container">
          <img className='store-img' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSW-3xYIFXNK7mQE-HQtDZ_GtxL0ipTonl4QQ&usqp=CAU" alt="store-img"/>
          <p className='store-text'>Jagityal</p>
        </div>
        <div className="franchise-ind-container">
          <img className='store-img' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAaLpVH2Nvqot_JWwdM4lwSpQ_F9YxLkEr3w&usqp=CAU" alt="store-img"/>
          <p className='store-text'>Proddatur</p>
        </div>

        <div className="franchise-ind-container">
          <img className='store-img' src="https://lh3.googleusercontent.com/YwTp5NNRNfXAQhE9GO8UEP6iW3PnxF_QBVsWkk6bWx9XX4lDrn4KmqqeCXOpIZF6u4lrJluw=w1080-h608-p-no-v0" alt="store-img"/>
          <p className='store-text'>Papely,kurnool</p>
        </div>

        <div className="franchise-ind-container">
          <img className='store-img' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqWZr6CibcrezT5r3V7aaZNzxn4H05mrfJMC0v14ZZ4N9Rh0V1j8G-IsCtmCU9t-G3WT0&usqp=CAU" alt="store-img"/>
          <p className='store-text'>Dilsuknagar, Hyderabad</p>
        </div>


        
      </div>

  
    </div>

  )

}